import React from "react"
import styled from 'styled-components'

import LinkButton from './Buttons/LinkButton'

import instagram from '../../images/icons/social/instagram.svg'
import twitter from '../../images/icons/social/twitter.svg'
import note from '../../images/icons/social/note.svg'

const SocialList = styled.ul`
  display: flex;
  flex-direction: row;
`

const Item = styled.li`
  & + & {
    margin-left: 2.4rem;
  }
  width: 40px;
  height: 40px;
`

const Icon = styled.img`
  width: 100%;
  height: 100%;
`

const Social = () => {
  return (
    <SocialList>
      <Item>
        <LinkButton href={'https://www.instagram.com/tamabi_idd_sotsuten/'}>
          <Icon src={instagram} alt="link to instagram" />
        </LinkButton>
      </Item>
      <Item>
        <LinkButton href={'https://twitter.com/tamabi_idd_gw'}>
          <Icon src={twitter} alt="link to twitter" />
        </LinkButton>
      </Item>
      <Item>
        <LinkButton href={'https://note.com/idd_sotsuten'}>
          <Icon src={note} alt="link to note" />
        </LinkButton>
      </Item>
    </SocialList>
  )
}

export default Social